module.exports = __webpack_public_path__ + "static/media/arrow-icon.ab47aa29.svg";